// extracted by mini-css-extract-plugin
module.exports = {"popover":"RightBar_popover__iWSxW"};